import { html, LitEntity } from '../../utility/lit-entity';
import './mtech-integration-modal';
import { IntegrationOverviewMixin } from './integration-overview-mixin';

class MtechIntegrationOverview extends IntegrationOverviewMixin(LitEntity) {
  render() {
    return this.renderOverview();
  }

  renderModal() {
    return html`
      <mtech-integration-modal
        title="${this.title}"
        .href="${this.href}"
        ?hide="${!this.showModal}"
        @close="${() => this.showModal = false}"
      ></mtech-integration-modal>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.integrationEnabled = this.entity.properties.installerCredentialsConfigured;
  }
}

window.customElements.define('mtech-integration-overview', MtechIntegrationOverview);
